import React, {useContext} from "react";
import "./StartupProjects.scss";
import {bigProjects} from "../../portfolio";
import {Fade} from "react-reveal";
import StyleContext from "../../contexts/StyleContext";

export default function StartupProject() {
  // Every footer button — internal "/projects/..." routes and external URLs alike — opens in a new tab.
  function handleLinkClick(url) {
    if (!url) return;
    var win = window.open(url, "_blank", "noopener,noreferrer");
    if (win) win.focus();
  }

  const {isDark} = useContext(StyleContext);
  if (!bigProjects.display) {
    return null;
  }
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="projects">
        <div>
          <h1 className="skills-heading">{bigProjects.title}</h1>
          <p
            className={
              isDark
                ? "dark-mode project-subtitle"
                : "subTitle project-subtitle"
            }
          >
            {bigProjects.subtitle}
          </p>

          <div className="projects-container">
            {bigProjects.projects.map((project, i) => {
              // Card-level click target: the "Learn More" footer link (i.e. the /projects/:slug route).
              // Falls back to whichever footer link exists.
              const learnMore =
                project.footerLink &&
                project.footerLink.find(l => l.name === "Learn More");
              const cardUrl = learnMore
                ? learnMore.url
                : project.footerLink && project.footerLink[0]
                ? project.footerLink[0].url
                : null;

              return (
                <div
                  key={i}
                  className={
                    isDark
                      ? "dark-mode project-card project-card-dark"
                      : "project-card project-card-light"
                  }
                  onClick={() => handleLinkClick(cardUrl)}
                  style={cardUrl ? {cursor: "pointer"} : undefined}
                  role={cardUrl ? "link" : undefined}
                  tabIndex={cardUrl ? 0 : undefined}
                  onKeyDown={e => {
                    if (cardUrl && (e.key === "Enter" || e.key === " ")) {
                      e.preventDefault();
                      handleLinkClick(cardUrl);
                    }
                  }}
                >
                  {project.image ? (
                    <div className="project-image">
                      <img
                        src={project.image}
                        alt={project.projectName}
                        className="card-image"
                      ></img>
                    </div>
                  ) : null}
                  <div className="project-detail">
                    <h5
                      className={isDark ? "dark-mode card-title" : "card-title"}
                    >
                      {project.projectName}
                    </h5>
                    <p
                      className={
                        isDark ? "dark-mode card-subtitle" : "card-subtitle"
                      }
                    >
                      {project.projectDesc}
                    </p>
                    {project.footerLink ? (
                      <div className="project-card-footer">
                        {project.footerLink.map((link, i) => {
                          return (
                            <span
                              key={i}
                              className={
                                isDark ? "dark-mode project-tag" : "project-tag"
                              }
                              onClick={e => {
                                e.stopPropagation();
                                handleLinkClick(link.url);
                              }}
                            >
                              {link.name}
                            </span>
                          );
                        })}
                      </div>
                    ) : null}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </Fade>
  );
}
